/* eslint-disable max-lines */
import FormWatcher from '@/inheritance/form-watcher';
const UploadDocument = () => import(/* webpackChunkName: "UploadDocument" */ '@/components/upload-document');

export default {
    name: 'RelatedTestAux',
    extends: FormWatcher,
    components: { UploadDocument },
    /**
     * @override
     */
    data() {
        return {
            showPoll: false,
            polls: [],
            form: [],
            pollsorig: null,
            optionSelected: 'null',
            submitted: false,
            client_type: '',
            uploadDocument: false,
            formErrors: [],
            uuidPrivate: null,
            formWatcherProperties: ['form']
        };
    },
    props: {
        section: {
            type: String,
            required: true
        },
        uuid: {
            type: String,
            required: false
        },
        uuid_intervener: {
            type: String,
            required: true
        },
        uuid_account: {
            type: String,
            required: false,
            default: ''
        },
        person_type: {
            type: String,
            required: false,
            default: null
        },
        mail: {
            type: String,
            required: false
        }
    },
    methods: {
        /**
         * Obtenemos la información del interviniente
         */
        fetchData() {
            this.uuidPrivate = this.uuid || this.$route.params.uuid;
            this.$pollsService.getPollQuestions('').then(res => {
                this.pollsorig = res.data.poll;
                this.pollsorig = JSON.stringify(this.pollsorig);
            });
        },
        /**
         * Fetch questions for poll
         */
        fetchPolls() { // TODO: datos interviniente principal
            this.polls = [];
            this.form = [];
            this.client_type = this.person_type;
            this.polls = JSON.parse(this.pollsorig).filter(x => {
                const value = [];
                if (x.is_deleted === true || x.client_type !== this.client_type) {
                    return null;
                }
                x.question = this.$t(`polls.questions.${x.question}`);
                if (['SELECT', 'RADIO', 'CHECKBOX'].includes(x.question_type)) {
                    x.responses.responses = x.responses.responses.map(y => {
                        const responses = {
                            value: y,
                            text: this.$t(`polls.responses.${y}`),
                            type: x.responses.type
                        };
                        y = responses;
                        return responses;
                    });
                    value.push(null);
                } else if (x.question_type === 'MULTI') {
                    x.responses = x.responses.map(multresponses => {
                        if (multresponses.responses) {
                            const responses_translated = [];
                            multresponses.responses.forEach(y => {
                                responses_translated.push({
                                    value: y,
                                    text: this.$t(`polls.responses.${y}`),
                                    type: multresponses.type
                                });
                            });
                            multresponses.responses = responses_translated;
                        }
                        multresponses.question = this.$t(`polls.questions.${multresponses.question}`);
                        value.push(null);
                        return multresponses;
                    });
                } else {
                    value.push(null);
                }
                this.form.push({
                    id_poll: x.id_poll,
                    id_question: x.id_question,
                    value,
                    type: x.question_type,
                    valid: true,
                    valid_cause: []
                });
                return x;
            });
            this.showPoll = true;
        },
        /**
         * @override
         */
        warnRequestPoll() {
            this.$bvModal.show('warn-modal');
        },
        /**
         * @override
         */
        closeModal() {
            this.$bvModal.hide('warn-modal');
        },
        /**
         * @override
         */
        cancelPoll() {
            this.showPoll = false;
            this.polls = [];
            this.form = [];
        },
        /**
         * @override
         */
        savePoll(evt) {
            evt.preventDefault();
            this.submitted = true;
            if (this.validateForm(this.form)) {
                const date = new Date();
                // eslint-disable-next-line prefer-const
                let promises = [];
                this.form.forEach((answer, i) => {
                    let poll_answer = {};
                    if (this.section === 'intervener') {
                        poll_answer = {
                            id_poll: answer.id_poll,
                            id_question: i,
                            created_on: date,
                            answer: answer.value,
                            uuid_intervener: this.uuid_intervener
                        };
                    } else {
                        poll_answer = {
                            id_poll: answer.id_poll,
                            id_question: i,
                            created_on: date,
                            answer: answer.value,
                            uuid_intervener: this.uuid_intervener,
                            uuid_account: this.uuidPrivate
                        };
                    }
                    if (Array.isArray(poll_answer.answer[0])) {
                        poll_answer.answer = poll_answer.answer[0];
                    }
                    promises.push(this.$pollsService.create(poll_answer));
                });
                Promise.all(promises)
                    .then(response => {
                        response.forEach(res => {
                            if (res.result) {
                                this.$toast.success('Test completado', res.result.info);
                            }
                        });
                        this.cancelPoll();
                    })
                    .catch(err => {
                        err.forEach(res => {
                            if (res.result) {
                                this.$toast.error('Test completado con errores', res.result.info);
                            }
                        });
                    });
            } else {
                this.$toast.error('Errores en el formulario', 'Por favor verifique los campos con error.');
                window.scrollTo(0, 0);
            }
            this.submitted = false;
        },
        /**
         * @override
         */
        requiredValidation(value, is_valid_form) {
            if (Array.isArray(value.value[0]) && value.value[0].length === 0) {
                value.valid = false;
                value.valid_cause.push('required');
                is_valid_form = false;
            } else if (!Array.isArray(value.value[0]) && (value.value[0] === null || value.value[0].trim() === '')) {
                value.valid = false;
                value.valid_cause.push('required');
                is_valid_form = false;
            } else {
                value.valid = true;
            }
            return is_valid_form;
        },
        /**
         * @override
         */
        freeFieldValidation(value, is_valid_form) {
            if (value.value[0].length < 4) {
                value.valid_cause.push('min_length');
                value.valid = false;
                is_valid_form = false;
            } else {
                value.valid = true;
            }
            return is_valid_form;
        },
        /**
         * @override
         */
        validateForm(newForm) {
            let is_valid_form = true;
            if (this.submitted) {
                newForm.forEach(value => {
                    value.valid_cause = [];
                    is_valid_form = this.requiredValidation(value, is_valid_form);
                    if (value.valid) {
                        switch (value.type) {
                            case 'FREE':
                                is_valid_form = this.freeFieldValidation(value, is_valid_form);
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
            return is_valid_form;
        },
        /**
         * @override
         */
        uploadOk() {
            this.uploadDocument = false;
        },

        /**
         * @override
         */
        sendNotification() {
            const payload = {
                uuid_intervener: this.uuid_intervener,
                uuid_account: this.uuid_account,
                notification_type: 'KNOWLEDGE_TEST',
                send_notification: true,
                send_mail: true,
                url: ``
            };

            this.$accountsService.createNotification(payload)
                .then(res => {
                    this.$toast.success('Notificación creada y enviada', res.result.info);
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));

            this.$bvModal.hide('warn-modal');
        }
    },
    watch: {
        'form': {
            /**
             * Guardamos la información del formulario en el estado global
             * @param {Object} newForm Formulario con nuevos valores
             */
            handler(newForm) {
                if (newForm !== this.form) {
                    this.validateForm(newForm);
                }
            }, deep: true
        }
    },
    /**
     * @override
     */
    beforeMount() {
        this.fetchData();
        const storedComponentData = this.getStoredComponentData();
        if (storedComponentData && Object.keys(storedComponentData).length) {
            Object.entries(storedComponentData).forEach(([key, value]) => this[key] = value);
        }
    }
};
